module.exports = __webpack_public_path__ + "static/media/Illus-Fall.97ed2857.png";